import React, { useState, useRef } from "react";
import Button from "./Button";

//components
import Popup from "./Popup";

//API
import api from "../services/api";

import {
  useForm
} from "react-hook-form";

import SocialMediaUser from "./SocialMediaUser";

//Auth
import { useAuth } from "../providers/auth";

//SVG's
import Instagram from "../svgs/Instagram";
import Facebook from "../svgs/Facebook";
import WhatsApp from "../svgs/WhatsApp";
import Telegram from "../svgs/Telegram";
import LoadingCenter from "./LoadingCenter";
import openToast from "../utils/sweetAlert";


const PopupSocialMediaUserNew = ({ trigger, socialMedias, setTrigger, setSelectedMedia, idCustomer, fetchMessagesById, handleChatBack, infoLoadingCriarChat }) => {

  const { user } = useAuth();

  const { register, handleSubmit } = useForm();

  const onSubmit = data => {
    setSelectedMedia(data.social_media);
    arrumirCliente(data.social_media);
    setTrigger(false);
  };

  function getMediaType(media) {
    switch (media) {
      case "Whatsapp":
        return <WhatsApp />;

      case "Instagram":
        return <Instagram />;

      case "Facebook":
        return <Facebook />;

      case "Telegram":
        return <Telegram />;
    }
  }

  // Nova Conversa
  async function arrumirCliente(media) {

    const options = { headers: { "Authorization": "Bearer " + user.token } };

    try {
      const response = await api.post("/users/assumir/novo/chat/" + idCustomer, { social_media: media }, options);

      if (response.data.error) {
        openToast("info", "Atenção", response.data.message);
      }

      if (!response.data.error) {
        openToast("success", "Sucesso", response.data.message);
      }
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <Popup title="Filtrar por rede social" trigger={trigger} setTrigger={setTrigger} >
      {infoLoadingCriarChat ? (
        <LoadingCenter />
      ) : (
        <div className="sm-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row-grid">
              {socialMedias.map((media, index) => {
                return (
                  <SocialMediaUser title={media} name="social_media" value={media} register={register} >
                    {getMediaType(media)}
                  </SocialMediaUser>
                )
              })}
            </div>
            <div className="popup-footer">
              <button className="btn btn-primary" type="submit">Concluir</button>
              <button className="btn btn-light mr-20" type="submit" onClick={() => setTrigger(false)}>Cancelar</button>
            </div>
          </form>
        </div>
      )}
    </Popup>
  );
}

export default PopupSocialMediaUserNew;